// First real funnel experiment.
//
// Tests a tighter, benefit-led welcome headline on the /2026 funnel.
//
// Hypothesis:
//   "SCREEN TIME REDUCTION PLAN" frames the value prop more concretely than
//   "PLAN YOUR SOCIAL MEDIA DETOX" and should lift welcome→s4 (social proof)
//   conversion. Detox framing is category-conventional and may feel
//   prescriptive; reduction framing names the user-controlled outcome.
//
// Primary metric (analyze in Amplitude):
//   Funnel: `Web Funnel - Welcome Viewed`  →  `Web Funnel - Funnel Step Viewed`
//   filtered to `event_properties.screen_id = 's4'`
//   grouped by `event_properties.experiments.welcome_2026_headline_v1`
//
// Targeting:
//   /2026 only, enforced at RENDER TIME in screens-phase1.jsx via
//   `currentFunnelSlug() === '2026'`. We attempted server-side targeting via
//   Amplitude segments on `funnel_slug = '2026'` but local-eval rejects that
//   shape ("Invalid targeting segment for local evaluation"). The render-time
//   gate is sufficient: only /2026 hits the wrapped surface, so only /2026
//   users fire exposure. The flag key + description make the scope explicit
//   for anyone re-using this code elsewhere.

import { defineExperiment } from '../src/lib/experiments/define';

export default defineExperiment({
  key: 'welcome_2026_headline_v1',
  name: 'Welcome /2026 — headline test #1',
  description:
    'Tests "SCREEN TIME REDUCTION PLAN" against the current "PLAN YOUR SOCIAL MEDIA DETOX" headline on the /2026 welcome screen. Primary metric is welcome→s4 (social proof) conversion.',
  evaluationMode: 'local',
  bucketingKey: 'amplitude_id',
  bucketingUnit: 'User',
  variants: [
    { key: 'control', description: 'PLAN YOUR SOCIAL MEDIA DETOX (current /2026 headline)' },
    { key: 'treatment', description: 'SCREEN TIME REDUCTION PLAN' },
  ],
  // Experiment concluded May 20, 2026 — statistically insignificant on 320
  // users / 2 days. Rolled out to control in the Amplitude UI. Weights
  // updated here to reflect the post-rollout state so future syncs don't
  // drift. The `<Experiment>` wrapper in screens-phase1.jsx now renders the
  // <Fallback> for every user (flag is Off in Amplitude); this surface can
  // be deleted in a follow-up cleanup.
  rolloutWeights: { control: 100, treatment: 0 },
  mutualExclusionGroup: 'welcome',
  // targetSegments intentionally omitted — local-eval rejects user-property
  // segment shapes. Scoping is enforced at render time (see comment above).
  experimentType: 'a-b-test',
  tags: ['welcome', '2026', 'headline'],
  primaryMetric: 'welcome_viewed_to_s4_social_proof_viewed',
});
